import { render, staticRenderFns } from "./MenuOption.vue?vue&type=template&id=ba5dcd14&scoped=true&"
import script from "./MenuOption.vue?vue&type=script&lang=js&"
export * from "./MenuOption.vue?vue&type=script&lang=js&"
import style0 from "./MenuOption.vue?vue&type=style&index=0&id=ba5dcd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5dcd14",
  null
  
)

export default component.exports